import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import store from '../store'


export const validationSchemas = (isHito) => {
   
  let validationObject = { };
if(isHito){validationObject["fechaHitoCambioGestion"] = Yup.date().required('La fecha es obligatoria.');}
   validationObject["codTipoGestionNuevo"] = Yup.date().required('Este campo es obligatorio.');
 
 

   validationObject["codAmbitoGestionNuevo"] = Yup.date().required('Este campo es obligatorio.');
 
  
  validationObject["minutaHitoCambioGestion"] = Yup.string().test(
    "len",
    "No puede exeder 1000 caracteres..",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length >= 0 && val.length <= 1000);
    }
  );
  validationObject["minutaHitoRespuesta"] = Yup.string().test(
    "len",
    "No puede exeder 1000 caracteres..",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length >= 0 && val.length <= 1000);
    }
  );
  return Yup.object().shape(validationObject);
}

